export default {
    imageDashboardTransaction: {
        action: 'Action',
        transactionId: 'Transaction Id',
        variationCount: 'Variation Count',
        date: 'Date',
        cost: 'Cost',
        description: 'Description',
        selectedImage: 'Selected Image',
        goTo: 'Go to',
    },
};
